export enum RoutePathType {
  NotFound = '*',
  Activation = '/activation',
  Admin = '/admin',
  AdminConsole = '/admin/console',
  AdminConsoleClient = '/admin/console/:clientId',
  AdminConsoleClientAuditLogs = '/admin/console/:clientId/audit-logs',
  AdminConsoleClientCopyWorkflow = '/admin/console/:clientId/copy-workflow',
  AdminConsoleClientDataFields = '/admin/console/:clientId/data-fields',
  AdminConsoleClientFieldManager = '/admin/console/:clientId/field-manager',
  AdminConsoleClientDepartments = '/admin/console/:clientId/departments',
  AdminConsoleClientDepartmentsDepartment = '/admin/console/:clientId/department/:departmentId',
  AdminConsoleClientEmailIntake = '/admin/console/:clientId/email-intake',
  AdminConsoleClientEntityTypes = '/admin/console/:clientId/entity-types',
  AdminConsoleClientEntityTypeDetail = '/admin/console/:clientId/entity-types/:entityTypeId',
  AdminConsoleClientIntegrations = '/admin/console/:clientId/integrations',
  AdminConsoleClientProcurement = '/admin/console/:clientId/procurement',
  AdminConsoleClientManagePartyLists = '/admin/console/:clientId/manage-party-lists',
  AdminConsoleClientMoreSettings = '/admin/console/:clientId/more-settings',
  AdminConsoleClientProcessDocuments = '/admin/console/:clientId/process-documents',
  AdminConsoleClientRestorationHub = '/admin/console/:clientId/restoration-hub',
  AdminConsoleClientSamlConfiguration = '/admin/console/:clientId/saml-configuration',
  AdminConsoleClientSamlConfigurationFormConfig = '/admin/console/:clientId/saml-configuration/form/:configId',
  AdminConsoleClientDocumentManagement = '/admin/console/:clientId/document-management',
  AdminConsoleClientCRM = '/admin/console/:clientId/crm',
  AdminConsoleClientApiManagement = '/admin/console/:clientId/api-management',
  AdminConsoleClientWebhooks = '/admin/console/:clientId/webhooks',
  AdminClientCredits = '/admin/:clientId/credits',
  AdminRoles = '/admin/:clientId/roles/',
  AdminUsers = '/admin/:clientId/users',
  AutomationHub = '/automation',
  AutomationHubFields = '/automation/fields',
  AutomationHubFieldModel = '/automation/fields/:modelId',
  AutomationHubFieldsDebug = '/automation/fields/debug',
  AutomationHubFieldsDebugModel = '/automation/fields/debug/:modelId',
  AutomationHubDetail = '/automation/detail',
  RoutingTable = '/automation/routing-table',
  Alerts = '/alerts',
  AgentForgeInvoke = '/agentforge-invoke',
  Onboarding = '/onboarding',
  ChangePassword = '/change-password',
  ClauseLibrary = '/clause-library',
  ClauseLibraryInstance = ':clauseId',
  Dashboards = '/dashboards/',
  Dashboard = '/dashboards/:dashboardId',
  DynamicDataExtraction = '/automation/dynamic-data-extraction',
  ViewDataExtraction = '/automation/dynamic-data-extraction/view-data-extraction/:extractionId',
  Document = '/document/:documentId',
  DocumentRedirect = '/document',
  DocumentsEntityType = '/documents/entity-types/:entityTypeId',
  DocumentsEntityTypeGroupDetail = '/documents/entity-types/:entityTypeId/entities/:groupId',
  Documents = '/documents',
  DocumentsFolder = '/documents/:folderId',
  DownloadEmailAttachmentPage = '/download-email-attachment',
  DownloadExportReportPage = '/download-export-report',
  ExpiredToken = '/expired-token',
  ExternalDocumentViewer = '/external-document-viewer',
  FoldersPermissionCheck = '/folders-permission-check',
  ForgotPassword = '/forgot-password',
  Guidelines = '/guidelines',
  GuidelineDetails = '/guidelines/:guidelineId',
  Home = '/',
  HomeSurface = '/home',
  Login = '/login',
  LoginEmbed = '/login/embed',
  LoginEmbedSuccess = '/login/embed/success',
  ManagedEntities = '/entities/parties',
  MyDeletedDocuments = '/my-deleted-items',
  Playbooks = '/playbooks',
  PlaybookDetails = '/playbooks/:playbookId',
  PlaygroundUnifiedFieldsRegistry = '/playground/unified-fields-registry',
  SavedDashboards = '/saved-dashboards',
  SavedSearches = '/saved-searches',
  Search = '/search',
  SavedSearch = '/search/:searchId',
  Settings = '/settings',
  SuperAdminUsers = '/super-admin/users',
  TicketEmailActionError = '/invalid-email-action-token/',
  TicketEmailApproveConfirmation = '/email-action-approve-succeeds/',
  TicketEmailApproveComment = '/tickets/:ticket_id/judgment-results/:judgment_result_id/:jwt/approve/',
  TicketEmailRejectComment = '/tickets/:ticket_id/judgment-results/:judgment_result_id/:jwt/reject/',
  TicketEmailRejectConfirmation = '/email-action-reject-succeeds/',
  Unauthorized = '/unauthorized',
  Upload = '/upload',
  WorkflowBuilder = '/workflow/builder',
  WorkflowBuilderWorkflow = '/workflow/builder/:workflowId',
  WorkflowIntakeFormLink = '/workflow/:workflowId/intake-form/link',
  IntegrateWorkflowIntakeFormLink = '/integrate-workflow/:workflowId/intake-form/link',
  IntegrateWorkflowAmendIntakeForm = '/integrate-workflow/amend/:contractRecordUniqueId/intake-form',
  WorkflowTickets = '/workflow/tickets',
  WorkflowTicketsNew = '/workflow/tickets/new',
  WorkflowTicketsTicket = '/workflow/tickets/:ticketId',
  WorkflowTicketsReroute = '/contract',
  WorkflowTicketsTicketReviewerVersionNumber = '/workflow/tickets/:ticketId/reviewer/:versionNumber',
  WorkflowCLMEvolutionRequests = '/workflows/requests',
  WorkflowCLMEvolutionNewRequest = '/workflows/requests/new',
  WorkflowCLMEvolutionRequestsDetail = '/workflows/requests/:ticketId',
  WorkflowCLMEvolutionEsignRedirect = '/workflows/esign-redirect',
  WorkflowCLMEvolutionWorkflows = '/workflows/workflow-builder',
  WorkflowCLMEvolutionWorkflowsDetail = '/workflows/workflow-builder/:workflowId',
  WordOnlineFile = '/word-online/:fileId',
  WordOnlineError = '/word-online-invalid-subscription',
  XRayLibrary = '/x-ray/library',
  XRayLibraryAdmin = '/x-ray/library/admin',
}
